<template>
  <b-card>
    <b-card-title class="text-left">Send to My Garmin</b-card-title>
    <b-card-sub-title v-if="user" class="text-left">
      Using <strong>Garmin Connect™&nbsp;</strong>
      <a href="https://connect.garmin.com/" target="_blank">
        <font-awesome-icon icon="external-link-alt"/>
      </a>
    </b-card-sub-title>
    <b-card-body>
      <!-- Still checking: neither Connect nor Connected, which would be a guess -->
      <b-card-text v-if="connected === null && !checkFailed">
        <b-skeleton type="button" width="90px" aria-label="Checking your Garmin connection"/>
      </b-card-text>

      <template v-else-if="connected === true">
        <b-card-text>
          <b-button v-b-hover="hoverHandler" @click="disconnect" :variant="isHovered ? 'danger' : 'success'" size="sm">{{
              isHovered ? 'Disconnect' : 'Connected'
            }}
          </b-button>
        </b-card-text>
      </template>

      <!-- Only when the server said so: an unknown state shows no button -->
      <template v-else-if="connected === false">
        <b-card-text>
          <b-button @click="connect" variant="primary" size="sm">Connect</b-button>
        </b-card-text>
      </template>
    </b-card-body>
    <div class="alert alert-warning mb-0" role="alert" v-if="connected === false">
      You are not connected
    </div>
    <div class="small text-secondary text-left" v-else-if="connected === null && checkFailed">
      Couldn't check your Garmin connection
    </div>
  </b-card>
</template>

<script>
import {getAuth} from 'firebase/auth';

export default {
  name: 'GarminConnector',
  props: {
    globalData: Object,
  },
  mounted() {
    this.refresh();
  },
  data() {
    return {
      user: Object,
      // null until the server says: not known yet
      connected: null,
      // The check failed and the state is still unknown
      checkFailed: false,
      isHovered: false,
    }
  },
  watch: {
    globalData: {
      handler() {
        this.refresh();
      },
      deep: true
    },
  },
  methods: {
    refresh() {
      // A refresh keeps the last known state meanwhile, so the card doesn't flicker
      this.$http.get(`/api/garmin/validate`)
          .then(response => {
            this.connected = Boolean(response.data.valid);
            this.checkFailed = false;
          })
          .catch(e => {
            // Not a reason to say "not connected": keep what's known, if anything
            this.checkFailed = true;
            console.log(e)
          })
    },
    hoverHandler(isHovered) {
      this.isHovered = isHovered;
    },
    connect() {
      // // TODO: refresh when expired
      getAuth().currentUser.getIdToken(false).then(function (idToken) {
        window.open(`/api/submit?id_token=${idToken}`,
            'newwindow',
            'width=500,height=1000');
      }).catch(function (e) {
        console.warn(e)
      });
    },
    disconnect() {
      this.$http.post(`/api/garmin/invalidate`)
          .then(() => {
            this.connected = false;
          })
          .catch(e => {
            console.warn(e)
          })
    }
  },
}
</script>

<style scoped>
</style>
